const cateRowMixin = {
  computed: {
    countLabel() {
      return Object.keys(this.categoriesMiraklsLabel).length === 1;
    }
  },
  methods: {
    addMiraklCategory(miraklCategory) {
      if (
        this.form.categoriesMirakls.findIndex(function(item) {
          return item.id === miraklCategory.id;
        }) === -1
      ) {
        let pickedCategory = (({
          "@id": atid,
          "@type": attype,
          hierarchyLabel,
          id
        }) => ({ "@id": atid, "@type": attype, hierarchyLabel, id }))(
          miraklCategory
        );
        this.form.categoriesMirakls.push(pickedCategory);
      } else {
        alert("L'attribut est déjà associé à cette catégorie");
      }
    }
  }
};
export { cateRowMixin };
